import Vue from "vue";
let t = 0;
let timer = null;
Vue.directive("iosInput", {
    inserted: function(el) {
        el.addEventListener("focusin", function() {
            if (timer) {
                clearTimeout(timer);
            }
            t = document.body.scrollTop || document.documentElement.scrollTop;
            window.console.log(t);
        });
        el.addEventListener("focusout", function() {
            if (timer) {
                clearTimeout(timer);
            }
            timer = setTimeout(() => {
                window.scroll(0, t);
            }, 200);
        });
    }
});
